let $services = jQuery('.service-button');

if ($services) {

  $services.on('click', function() {

    let service          = this.getAttribute('service');
    let jSelector        = jQuery('.service-tab');
    let nodeSource       = document.getElementById(service);
    let nodeTarget       = document.getElementsByClassName('service-tab')[0];

    // copy the elements to inject
    let titleSource      = nodeSource.children[0].cloneNode(true);
    let copySource       = nodeSource.children[1].cloneNode(true);
    let buttonSource     = nodeSource.children[2].cloneNode(true);

    jQuery(jSelector).fadeOut(500, function() {
      nodeTarget.innerHTML = '';
      nodeTarget.appendChild(titleSource);
      nodeTarget.appendChild(copySource);
      nodeTarget.appendChild(buttonSource);
      jQuery(jSelector).fadeIn(500);
    });

  });

}
